import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../../Component/Model/helpers';

const quillMaxTest = (max: number, label: string) =>
    yup.string().nullable().test(
        `${label}MaxLength`,
        `${label} exceeds the maximum of ${max} characters`,
        (value) => {
            if (!value) return true;
            return DataTableHtmlFormatter(value, '').length <= max;
        }
    );

export const individualJustificationSchema = yup.object({
    reasonId: yup
        .number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .required('Justification Reason is required')
        .typeError('Justification Reason is required'),
    comment: yup
        .string()
        .nullable()
        .required('Commentary is required')
        .test('commentMaxLength', 'Commentary exceeds the maximum of 1000 characters', (value) => {
            if (!value) return true;
            return DataTableHtmlFormatter(value, '').length <= 1000;
        }),
    remedialPlan: quillMaxTest(1000, 'Remedial Plan'),
    auditDepartmentOrDivision: yup.string().nullable().max(255, 'Department or Division exceeds 255 characters'),
    auditJobTitle: yup.string().nullable().max(255, 'Job Title exceeds 255 characters'),
    auditUrgencyLevel: quillMaxTest(1000, 'Urgency Level'),
    eePlanJobProfile: quillMaxTest(500, 'Job Profile'),
    eePlanChannelsJobAdvertised: quillMaxTest(500, 'Channels Job was Advertised'),
    eePlanCoreResponseNumbers: quillMaxTest(500, 'Core Response Numbers'),
    eePlanShortlistedCandidatesDemographics: quillMaxTest(500, 'Short-Listed Candidates Demographics'),
    candidateQualifications: quillMaxTest(500, 'Qualifications'),
    candidatePriorLearning: quillMaxTest(500, 'Prior Learning'),
    candidateRelevantExperience: quillMaxTest(500, 'Relevant Experience'),
    approvedByRecruitingLineManager: yup.string().nullable().max(100, 'Recruiting Line Manager exceeds 100 characters'),
    approvedBySeniorManagerEE: yup.string().nullable().max(100, 'Senior Manager Responsible for EE exceeds 100 characters'),
    approvedByCeoOrDesignee: yup.string().nullable().max(100, 'CEO or Their Designated Appointee exceeds 100 characters'),
});
